import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa } from '../../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ReplacementTrackingService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/track-replacement/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/track-replacement/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/track-replacement/backoffice-ep';
    this.httpClient = http;
  }

  getTracking(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const requestOptions: Object = {
        responseType: 'json',
        headers: this.getHttpHeader(visa),
        body: dtoObject, // Send the DTO object in the request body
    };

    return this.httpClient.get<ApiResponseModel<any>>(
        this.apiUrl,
        requestOptions
    );
}
}
